export default __webpack_public_path__ + "static/media/aera.d3d6af7f.png";